import type { FC } from 'react';
import React from 'react';

import type { TFio } from './models';

export const Fio: FC<TFio> = ({ FioThreeField, OneFieldFio, oneFieldFio, ...rest }) =>
    oneFieldFio ? (
        <OneFieldFio {...rest} />
    ) : (
        <FioThreeField
            checkboxColor={rest.checkboxColor}
            genderTagsSize="xs"
            name={{
                lastName: 'lastName',
                firstName: 'firstName',
                middleName: 'middleName',
                gender: 'gender',
            }}
            settings={rest.settings}
            styler={{ marginBottom: 24 }}
        />
    );
